
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 42"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#231F20","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M20.69 28.747c.007.008.015.013.021.021l1.924 2.136 1.827-1.827 1.07-1.069 9.054-9.056a2.045 2.045 0 00-2.891-2.892l-6.99 6.992V2.08a2.046 2.046 0 00-4.091 0v20.466l-6.464-7.179a2.046 2.046 0 00-3.041 2.737l9.581 10.644z"}}),_c('path',{attrs:{"d":"M43.455 25.602c-1.13 0-2.046.915-2.046 2.046v10.226H4.59V27.647a2.045 2.045 0 00-4.091 0V39.92c0 1.13.916 2.047 2.046 2.047h40.909c1.13 0 2.045-.916 2.045-2.047V27.648c0-1.13-.915-2.046-2.045-2.046"}})])])
          )
        }
      }
    